import { api } from '../api';

/**
 * A identificação que toda ficha de ensaio mostra no topo (onda 236).
 *
 * Uma chamada só, e não a ficha montando o cabeçalho com pedaços de três
 * telas: OS, cliente e obra, amostra, origem, quem executou e a norma
 * VIGENTE da ficha. A norma vai pelo código (`NBR 6457`) porque o LA tem
 * duas fichas — LL e LP — e o método aponta para uma norma só.
 */
export interface DadosDaFicha {
  id: string;
  status: string;
  metodo_codigo: string;
  metodo_nome: string;
  os_id: string | null;
  os_numero: string | null;
  cliente: string | null;
  obra_nome: string | null;
  amostra_id: string | null;
  amostra_codigo: string | null;
  /** Onda 303 (RN-248): o nome que o cliente deu à amostra. */
  amostra_identificacao?: string | null;
  tipo_amostra: string | null;
  tipo_acondicionamento: string | null;
  ponto_investigacao: string | null;
  profundidade_inicial: number | string | null;
  profundidade_final: number | string | null;
  executado_por_nome: string | null;
  data_execucao: string | null;
  norma: string | null;
}

export const verFicha = (id: string, norma?: string) =>
  api<DadosDaFicha>(`/ensaios/${id}/ficha${
    norma ? `?norma=${encodeURIComponent(norma)}` : ''}`);
